import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helium',
  templateUrl: './helium.component.html',
  styleUrls: ['./helium.component.css']
})
export class HeliumComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
